import React from 'react';
import { streamSkeletonStyles } from '../../styles/streamSkeletonStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useWindowDimensions from '../../theme/useWindowDimensions';
import DotLoader from './dotLoader';

const useStyles = makeStyles((theme) => streamSkeletonStyles(theme));

const StreamSkeleton = () => {
  const classes = useStyles();
  const { width, height } = useWindowDimensions();

  return (
    <>
      <div className={classes.root}>
        <div style={{ position: 'absolute' }}>
          <DotLoader text={'Connecting Event'} />
        </div>
        <div
          className={classes.container}
          style={{
            height: height,
          }}
        >
          <div className={classes.leftContainer}>
            <div className={classes.liveScreen}></div>

            <div className={classes.comment}></div>
          </div>

          <div className={classes.rightContainer}>
            <div className={classes.videoChat}></div>
          </div>
        </div>

        <div className={classes.footerContainer}>
          <div className={classes.footer}></div>
        </div>
      </div>
    </>
  );
};

export default StreamSkeleton;
